/**
 * Application Entry Point
 *
 * This file initializes the React application and any global services.
 * Order of initialization matters:
 * 1. Faro telemetry (to capture any errors during app bootstrap)
 * 2. React root rendering
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from '@app/App';
import { initializeFaro } from '@shared/telemetry';
import '@styles/global.css';

// Initialize Faro telemetry BEFORE React renders
// This ensures we capture any errors during React initialization
// Initialization is safe even if VITE_FARO_URL is not configured
initializeFaro();

// Render the React application
ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
